import React, { useEffect, useState } from "react";
import { formatISTDate, getISTDateOnlyTimestamp } from "../utils/dateTime";

const BASE_URL = "/v1";

function ExpiryAlert({ user, onError }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    // collapsed by default
    const [collapsed, setCollapsed] = useState(true);

    useEffect(() => {
        fetchExpiryItems();
    }, []);

    const fetchExpiryItems = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            const res = await fetch(`${BASE_URL}/stocks/expiring-soon`, {
                headers: {
                    Authorization: "Bearer " + token
                }
            });

            const data = await res.json();
            setItems(data || []);

        } catch (err) {
            console.error("Expiry fetch failed", err);
            onError?.("danger", "Cannot load expiry items right now. Please check the backend server.");
        } finally {
            setLoading(false);
        }
    };

    // only for admin role
    if (user?.role !== 3) return null;

    if (!loading && items.length === 0) return null;

    const todayTimestamp = getISTDateOnlyTimestamp(new Date());

    return (
        <div className="card mb-3 border-warning shadow-sm overflow-hidden">
            <div
                className="card-header d-flex justify-content-between align-items-center"
                style={{
                    cursor: "pointer",
                    background: "linear-gradient(135deg, rgba(250, 204, 21, 0.2), rgba(255, 255, 255, 0.96))",
                    color: "#854d0e",
                    borderBottom: "1px solid rgba(250, 204, 21, 0.22)"
                }}
                onClick={() => setCollapsed(!collapsed)}
            >
                <strong>
                    Expiry Alert (3 Months Later)

                    {items.length > 0 && (
                        <span className="ms-2 badge bg-dark">
                            {items.length}
                        </span>
                    )}
                </strong>

                <div className="d-flex align-items-center gap-2">
                    <button
                        className="btn btn-sm btn-dark"
                        onClick={(e) => {
                            e.stopPropagation();
                            fetchExpiryItems();
                        }}
                    >
                        Refresh
                    </button>

                    <span style={{ fontSize: "18px", fontWeight: "bold", color: "#854d0e" }}>
                        {collapsed ? "▼" : "▲"}
                    </span>
                </div>
            </div>

            {!collapsed && (
                <div
                    className="card-body p-2"
                    style={{ maxHeight: "220px", overflowY: "auto" }}
                >
                    {loading ? (
                        <div className="text-center p-2">
                            Loading...
                        </div>
                    ) : (
                        <table className="table table-sm table-bordered mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Barcode / Product</th>
                                    <th>Expiry</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {items.map((item) => {
                                    const expiryTimestamp = getISTDateOnlyTimestamp(item.expiryDate);
                                    const isExpired = expiryTimestamp !== null && expiryTimestamp < todayTimestamp;

                                    return (
                                        <tr key={item.id}>
                                            <td>
                                                <div style={{ fontWeight: "600" }}>
                                                    {item.product?.barcode}
                                                </div>

                                                <div>
                                                    {item.product?.name}
                                                </div>

                                                <small className="text-muted">
                                                    {item.product?.category}
                                                </small>
                                            </td>

                                            <td>
                                                {formatISTDate(item.expiryDate)}
                                            </td>

                                            <td>
                                                {isExpired ? (
                                                    <span className="badge bg-danger">
                                                        Expired
                                                    </span>
                                                ) : (
                                                    <span className="badge bg-warning text-dark">
                                                        Expiring Soon
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
        </div>
    );
}

export default ExpiryAlert;
